import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const budgetcalculationpage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { BudgetCalculationPage } = await import(
        /* webpackChunkName: "BudgetDivisionCostsPage" */ '../../../components/pages/private/BudgetCalculationPage'
      )
      return {
        default: BudgetCalculationPage,
      }
    })}
    exact
    key={paths.budgetCalculation}
    path={paths.budgetCalculation}
  />,
]
